export default {
    title: 'Moja korpa',
    chooseDeliveryLocation: "Odaberi lokaciju dostave",
    backButton: 'Nazad u prodavnicu',
    proceedError: 'Molimo proverite da li su količine proizvoda dobre i da li ste zadovoljili minimalni zahtev za cijenu isporuke za svaku od prodavnica.',
    sideCard: {
        title: "Pregled narudžbine",
        sum: "Suma",
        delivery: "Dostava",
        surcharge: "Doplata",
        total: "Ukupno",
        proceedButton: "Plati"
    },
    storeCard: {
        items: {
            only: 'Samo',
            leftInStorage: 'ostalo u skladištu',
            zero: 'Količina mora biti makar',
            outOfStock: 'Nema na stanju'
        },
        priceColumn: {
            surcharge: "Doplata",
            cashOnDelivery: "Pouzećem",
            delivery: "Dostava",
            deliveryDate: 'Okvirni datum isporuke',
        },
        removedItem: {
            text: "je uklonjen iz prodavnice",
            button: "Otkaži"
        },
        footer: {
            message: {
                dependCityPrice: "Cijene dostave i doplate zavise od grada u kome se narudžbina isporučuje.",
                warning: {
                    deliverToAddress: "Prodavnica ne vrši dostavu ka odabranoj adresi.",
                    orderValue: {
                        minumum: "Prodavnica ne vrši dostavu robe ukupne vrijednosti manje od",
                        current: "Trenutna vrijednost"
                    }
                }
            }
        }
    },
    bannerPayment: {
        methods: "Načini plaćanja",
        safeShopping: {
            text: "Sigurna kupovina",
            description: "Siguran povraćaj novca ukoliko je proizvod neisporučen ili ne odgovara opisu."
        },
        cashOnDelivery: "Pouzećem"
    },
    reccomendedProducts: "Preporučeni proizvodi",
    successDeleteMessage: "Proizvod je uspješno uklonjen iz Vaše korpe.",
    successWishListMessage: "Proizvod je uspješno uklonjen iz Vaše korpe i dodat u Vašu listu želja.",
    modal: {
        title: "Moja korpa",
        total: "Ukupno",
        seeCart: "Pregled korpe",
        detailsInfo: "Detalje o troškovima dostave i dostupnoj količini možete pogledati u korpi."
    },
    addedToCart: {
        title: "Proizvod je dodat u korpu",
        quantity: "Količina"
    },
    swal: {
        moveToWishlist: "Prebacićete ovaj proizvod u vašu Listu želja.",
        removeFromCart: "Uklonićete ovaj proizvod iz vaše korpe."
    }
}
